define([
	"dojo/_base/declare",
	"../SizeChart",
	"./Actual"
], function(declare,SizeChart,Actual) {

	return declare(Actual, {
		getDefaultValue: function(/*Heading*/h) {
			// summary: return default value for heading
			return this.DEFAULT;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: change context to correct Sample based on keyValue - path always takes us to first Sample for selected size
			var	scd = ctx.getNode();
			ctx.keyValue = this._getDimensionActualsKey(ctx, scd);
			ctx.keyValue2 = this._getDimensionActualsKeyPre47(ctx, scd);
			ctx.keySuffix = this._getDimensionActualsKeySuffix(ctx, scd);   // To support unlinked/special SizeChartDimension
			ctx.pushParams().setNodeURL(ctx.view._urlSampleDims);
			ctx.setReadOnly(false);
			this.inherited(arguments);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: set index for Sample.ProductSize in SizeChart.SizeRange
			ctx.pop();
			this.inherited(arguments);
		},

		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return difference between value and target - if target is unknown, then no color-coding
			return (target == this.DEFAULT) ? 0 : (value - target);
		},

		_getTarget: function(/*Context*/ctx) {
			// summary: return target value for dimension
			var	n = ctx.view._nSizeIndex;
			if (n < 0) {
				return ctx.dynamicNumber ? 0 : this.DEFAULT;
			}

			var	dim = SizeChart.getSizeChartDimension(ctx);
			ctx.pushParams().setNode(dim);
			var	dimValues = SizeChart.getDimensionValues(ctx, "Increments");
			ctx.pop();

			// see if we are on a 1-D dimension on a 2-D size chart
			const scRev = ctx.cache.getNode(dim.__Parent__);
			const dim2Type = scRev.Dimension2Type;
			const actual = ctx.cache.getNode(dim.Actual);

			if (actual && ctx.cache.getNode(scRev.SizeRange).IsTwoDim && !actual.DimensionDependencies.includes(dim2Type)) {
				// fold from 2D to 1D
				const dim1Size = ctx.cache.getNode(scRev.Sizes[n]).Dimension1Size;
				n = scRev.SizeChartDimension1Sizes.indexOf(dim1Size);
			}

			return dimValues.abs[n];
		}
	});
});